import { Component, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Api, ApplicationVariables } from '../../providers/api';
import { Subscription } from 'rxjs';

import { MatSnackBar, MatDialog } from '@angular/material';
// import {dateConverter, utcDateConverter} from "../../config";
import { Angular2Csv } from "angular2-csv";
import { ApiBilling } from "../../providers/api.billing";
import { MatDatepicker } from "@angular/material/datepicker";
import { FormControl } from '@angular/forms';


@Component({
  selector: 'transaction-consumed-dialog',
  template: require('./transaction-consumed-dialog.component.html')

})
export class TransactionConsumedDialogComponent {

  busy: Subscription;
  uploading: Subscription;
  fromDate: any;
  toDate: any;
  valiationDialogRef: any;
  startDate: any;
  endDate: any;
  isSupplierTransaction = 0;
  selectedSupplierUuid = ""

  selectedYear
  selectedMonth
  years = ["2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030"]
  months = [{ id: 0, name: "January" },
  { id: 1, name: "February" },
  { id: 2, name: "March" },
  { id: 3, name: "April" },
  { id: 4, name: "May" },
  { id: 5, name: "June" },
  { id: 6, name: "July" },
  { id: 7, name: "August" },
  { id: 8, name: "September" },
  { id: 9, name: "October" },
  { id: 10, name: "November" },
  { id: 11, name: "December" }]

  customerType = "";

  constructor(private apiBilling: ApiBilling, private matDialog: MatDialog, public dialogRef: MatDialogRef<TransactionConsumedDialogComponent>, private api: Api) {
    this.dialogRef.disableClose = true;
    let year = new Date().getFullYear();
    this.startDate = new Date(year, 0, 1);
    this.endDate = new Date();

    this.isSupplierTransaction = ApplicationVariables.supplierTransaction
    this.selectedSupplierUuid = ApplicationVariables.selectedSupplierUuid

    this.customerType = localStorage.getItem("customerType");

  }





  public fileIsOver: boolean = false;
  @Output() public options = {
  };

  private file: File;

  public fileOver(fileIsOver: boolean): void {
    this.fileIsOver = fileIsOver;
  }

  downloadTemplate() {


    if (this.selectedYear === undefined || this.selectedYear === "") {
      // @ts-ignore
      this.api.toastMsg("Please select year first", "");
      return
    }
    if (this.selectedMonth === undefined || this.selectedMonth === "") {
      // @ts-ignore
      this.api.toastMsg("Please select month first", "");
      return;
    }

    // alert("UD")

    // alert("start" + dateConverter(this.startDate))
    // alert("endDate" + dateConverter(this.endDate))

    // let from = dateConverter(this.startDate);
    // let to = dateConverter(this.endDate);

    var month = this.selectedMonth.id; // January
    var d = new Date(parseInt(this.selectedYear), month + 1, 0).getDate();
    // alert(d.toString());

    // 2022-8-28
    let from = this.selectedYear + "-" + (this.selectedMonth.id + 1) + "-1";
    let to = this.selectedYear + "-" + (this.selectedMonth.id + 1) + "-" + d.toString();

    if (this.isSupplierTransaction) {
      this.apiBilling.get("lms/getTransactionsByDate?customerUUID=" + this.selectedSupplierUuid +
        "&startDate=" + from.toString() + "&endDate=" + to.toString() + "&linkedSystemUuid=" + localStorage.getItem("uuid")).subscribe((res) => {
          let result = res.json();
          this.generateTransactionsLogsForSupplier(result.data)
        });
    } else {
      // alert("inside else " + this.customerType)
      this.apiBilling.get("lms/getTransactionsByDate?customerUUID=" + this.api.getADPCustomerUUID() +
        "&startDate=" + from.toString() + "&endDate=" + to.toString() + "&linkedSystemUuid=").subscribe((res) => {
          let result = res.json();
          if (this.customerType === "Warehouse")
            this.generateTransactionsLogs(result.data)
          else
            this.generateTransactionsLogsForSupplier(result.data)

        });
    }




    // this.busy = this.api.get('orders/quickbook?todate='+from.toString()+'&fromdate='+to.toString())
    // .map(res=>res.text())
    // .subscribe(res=>{
    //   console.log('orders data', res);
    //   // console.log(js2xmlparser.parse("OrdersList", data));
    //   this.download('orders.csv', res);
    // }, err=>{
    //   alert('there is error in integration'+ err);
    // })

  }

  generateTransactionsLogs(data: any) {
    console.log('first entry', data[0], "length", data.length);
    let exportObject = [];
    let transactionType: string = "";
    for (var i = 0, len = data.length; i < len; i++) {
      if (data[i].quantityConsumed > 0) {
        transactionType = "Consumed";
      } else if (data[i].quantityConsumed == 0) transactionType = "Purchased";

      // if(data[i].transactionType.includes("monthly")){
      // 	data[i].transactionType = "Intellistock - Inventory Management (Monthly)";
      // } else if (data[i].transactionType.includes("yearly")){
      // 	data[i].transactionType = "Intellistock - Inventory Management (Yearly)";
      // }else if (data[i].transactionType.includes("topup")){
      // 	data[i].transactionType = "Integrations EDI TopUp";
      // }


      let workOrder = null;
      if (data[i].workOrderJson != null && data[i].workOrderJson !== undefined) {
        workOrder = JSON.parse(data[i].workOrderJson);
      }

      // let workOrderSkus = []
      // if(workOrder.skusJson !== undefined)
      //   workOrderSkus  = JSON.parse(workOrder.skusJson);

      let Header = ['Serial No.', 'Transaction Time', 'Supplier Name', 'Plan Name', 'Transaction Type'
        , 'Quantity', 'Transaction Consumed',
        'Cost', 'Transaction Per Resource', 'Invoice No', 'Order Id', 'User Name'];

      // let obj = {
      //   SerialNo:i+1,
      //   TransactionTime: data[i].transactionTime,
      //   PlanName: data[i].transactionType,
      //   TransactionType:transactionType,
      //   TransactionsAmount: data[i].amount,
      //   QuantityPurchased: data[i].quantityPurchased,
      //   QuantityConsumed: data[i].quantityConsumed,
      //   QuantityBalance: data[i].quantityBalance,
      //   InvoiceNo: data[i].invoiceIdFormula,
      //   OrderId: data[i].orderId,
      //   UserName: data[i].userName
      // };
      // console.log(row);

      let obj = {
        SerialNo: i + 1,
        TransactionTime: data[i].transactionTime,
        supplierName: workOrder !== null || undefined ? workOrder.supplierName : "",
        PlanName: data[i].transactionType,
        TransactionType: transactionType,
        resourceQuantity: workOrder !== null || undefined ? this.checkIfUndefined(workOrder.skusCount) : "",
        QuantityConsumed: data[i].quantityConsumed,
        cost: this.checkIfUndefined(data[i].cost),
        transactionPerResource: workOrder !== null || undefined ? this.checkIfUndefined(workOrder.consumeTransactionTier1) : "",
        // TransactionsAmount: data[i].amount,
        QuantityBalance: data[i].quantityBalance,
        // QuantityPurchased: data[i].quantityPurchased,
        InvoiceNo: data[i].invoiceIdFormula,
        OrderId: data[i].orderId,
        UserName: data[i].userName
      };
      transactionType = "";
      exportObject.push(obj);

    }
    let filename = "Transactions Logs";
    this.downloadTransactionsLogs(filename, exportObject);
  }

  downloadTransactionsLogs(filename, text) {
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      useBom: true
    };
    // let Header = ['Serial No.','Transaction Time','Plan Name', 'Transaction Type','Amount ($)','Quantity','Consumed','Available Balance','Invoice No','Order Id', 'User Name'];

    let Header = ['Serial No.', 'Transaction Time', 'Supplier Name', 'Plan Name', 'Transaction Type', 'Quantity', 'Transaction Consumed', 'Cost', 'Transaction Per Resource', 'Available Balance', 'Invoice No', 'Order Id', 'User Name'];
    new Angular2Csv(text, filename.split(".")[0], { headers: (Header) });

  }

  checkIfUndefined(string) {
    if (string == undefined || string == null) {
      return ""
    } else {
      return string
    }
  }

  generateTransactionsLogsForSupplier(data: any) {
    console.log('first entry', data[0], "length", data.length);
    let exportObject = [];
    let transactionType: string = "";
    for (var i = 0, len = data.length; i < len; i++) {
      if (data[i].quantityConsumed > 0 && data[i].workOrderJson !== null && data[i].workOrderJson !== undefined && data[i].workOrderJson !== "") {
        //   transactionType ="Consumed";
        // } else if(data[i].quantityConsumed == 0) transactionType ="Purchased";

        // if(data[i].transactionType.includes("monthly")){
        // 	data[i].transactionType = "Intellistock - Inventory Management (Monthly)";
        // } else if (data[i].transactionType.includes("yearly")){
        // 	data[i].transactionType = "Intellistock - Inventory Management (Yearly)";
        // }else if (data[i].transactionType.includes("topup")){
        // 	data[i].transactionType = "Integrations EDI TopUp";
        // }

        let workOrder = JSON.parse(data[i].workOrderJson);
        let workOrderSkus = []
        if (workOrder.skusJson !== undefined)
          workOrderSkus = JSON.parse(workOrder.skusJson);
        let obj
        if (this.customerType === "Supplier") {
          obj = {
            name: this.checkIfUndefined(workOrder.name),
            referenceNo: this.checkIfUndefined(workOrder.referenceNo),
            finishedAt: this.checkIfUndefined(data[i].transactionTime),
            transactionConsumed: this.checkIfUndefined(data[i].quantityConsumed),
            resourceQuantity: this.checkIfUndefined(workOrder.skusCount),
            cost: this.checkIfUndefined(data[i].cost),
            resourceType: this.checkIfUndefined(workOrder.resourceType),
            transactionPerResource: this.checkIfUndefined(workOrder.consumeTransactionTier1),
            resourceCount: this.checkIfUndefined(workOrderSkus.length),
            a3plName: this.checkIfUndefined(workOrder.warehouseName),
            sops: this.checkIfUndefined(workOrder.sopLogJson),
            type: this.checkIfUndefined(workOrder.type),
            createdAt: this.checkIfUndefined(workOrder.createdAt),
            startedAt: this.checkIfUndefined(workOrder.startedAt),






            // SerialNo: i + 1,
            // TransactionTime: data[i].transactionTime,
            // PlanName: data[i].transactionType,
            // TransactionType: transactionType,
            // TransactionsAmount: data[i].amount,
            // QuantityPurchased: data[i].quantityPurchased,
            // QuantityConsumed: data[i].quantityConsumed,
            // QuantityBalance: data[i].quantityBalance,
            // InvoiceNo: data[i].invoiceIdFormula,
            // OrderId: data[i].orderId,
            // UserName: data[i].userName
          };
        } else {
          obj = {
            name: this.checkIfUndefined(workOrder.name),
            referenceNo: this.checkIfUndefined(workOrder.referenceNo),
            finishedAt: this.checkIfUndefined(data[i].transactionTime),
            transactionConsumed: this.checkIfUndefined(data[i].quantityConsumed),
            resourceQuantity: this.checkIfUndefined(workOrder.skusCount),
            cost: this.checkIfUndefined(data[i].cost),
            resourceType: this.checkIfUndefined(workOrder.resourceType),
            transactionPerResource: this.checkIfUndefined(workOrder.consumeTransactionTier1),
            resourceCount: this.checkIfUndefined(workOrderSkus.length),
            supplier: this.checkIfUndefined(workOrder.supplierName),
            sops: this.checkIfUndefined(workOrder.sopLogJson),
            type: this.checkIfUndefined(workOrder.type),
            createdAt: this.checkIfUndefined(workOrder.createdAt),
            startedAt: this.checkIfUndefined(workOrder.startedAt),






            // SerialNo: i + 1,
            // TransactionTime: data[i].transactionTime,
            // PlanName: data[i].transactionType,
            // TransactionType: transactionType,
            // TransactionsAmount: data[i].amount,
            // QuantityPurchased: data[i].quantityPurchased,
            // QuantityConsumed: data[i].quantityConsumed,
            // QuantityBalance: data[i].quantityBalance,
            // InvoiceNo: data[i].invoiceIdFormula,
            // OrderId: data[i].orderId,
            // UserName: data[i].userName
          };
        }

        transactionType = "";
        exportObject.push(obj);
      }

    }
    let filename = "Transactions Logs";
    this.downloadTransactionsLogsForSupplier(filename, exportObject);
  }

  downloadTransactionsLogsForSupplier(filename, text) {
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      useBom: true
    };
    // let Header = ['Work Order Name','Work Order Type','Created At', 'Started At','Finished At','SOP','Reference #','Transaction Consumed','A3Pl Name','Cost'];
    let Header = ['Work Order Name', 'Reference #', 'Finished At', 'Transaction Consumed', 'Resource Quantity', 'Cost', 'Resource Type', 'Transaction Per Resource', 'Resource Count', 'A3PL', 'SOP', 'Service', 'Created At', 'Started At'];
    if (this.customerType !== "Supplier") {
      Header = ['Work Order Name', 'Reference #', 'Finished At', 'Transaction Consumed', 'Resource Quantity', 'Cost', 'Resource Type', 'Transaction Per Resource', 'Resource Count', 'Supplier', 'SOP', 'Service', 'Created At', 'Started At'];
    }
    new Angular2Csv(text, filename.split(".")[0], { headers: (Header) });

  }


  //   download(filename, text) {
  //     //this.api.downloadSaveFile(filename, text);
  //       var pom = document.createElement('a');
  //     pom.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(text));
  //     pom.setAttribute('download', filename);

  //     if (document.createEvent) {
  //         var event = document.createEvent('MouseEvents');
  //         event.initEvent('click', true, true);
  //         pom.dispatchEvent(event);
  //     }
  //     else {
  //         pom.click();
  //     }
  //     // document.removeChild(pom);
  // }

  download(filename, text) {
    this.api.downloadSaveFile(filename, text);
  }


  close() {
    this.dialogRef.close();
  }
  // closeV(){
  //   this.valiationDialogRef.close();
  // }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/billing/home/transaction-consumed-dialog.component.ts